<kendo-dialog *ngIf="dialogOpened" (close)="cancelFilter();" [minWidth]="300" [width]="600">
  <kendo-dialog-titlebar>
    <h3>{{ 'SAVE-FILTER' | translate}}</h3>
  </kendo-dialog-titlebar>
  <form #filterForm="ngForm" class="k-form">
    <label class="k-form-field">
      <span class="k-text-uppercase dark">{{ 'FILTER-NAME' | translate }} *</span>
      <input id="filterName" name="filterName" kendoTextBox required minlength="2" [(ngModel)]="filterName">
      <div class="k-tooltip k-tooltip-validation" role="alert"
        *ngIf="filterNameControl !== undefined && filterNameControl.hasError('required') && filterNameControl.touched">
        {{'REQUIRED-NAME' | translate}}
      </div>
    </label>
    <label class="k-form-field" *ngIf="showSystemFilter">
      <span class="k-text-uppercase dark mr-2">{{ 'SYSTEM-FILTER' | translate }}</span>
      <kendo-switch [(ngModel)]="filterSystem" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}"
        [ngModelOptions]="{standalone: true}" [disabled]="!systemFilterEnabled">
      </kendo-switch>
    </label>
    <label *ngIf="filterCategory === 'Event'" class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'ORGANIZATION' | translate}}
      </span>
      <kendo-combobox id="organization" [(ngModel)]="organization" class="w-100" [valuePrimitive]="false"
        [data]="organizations" [textField]="'name'" [valueField]="'id'" [itemDisabled]="itemDisabled"
        [ngModelOptions]="{standalone: true}">
      </kendo-combobox>
    </label>
    <label *ngIf="filterCategory === 'Event'" class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'APPLY-ON' | translate}}
      </span>
      <kendo-combobox id="screen" [(ngModel)]="screen" class="w-100" [valuePrimitive]="false" [data]="filterScreen"
        [textField]="'text'" [valueField]="'value'" [ngModelOptions]="{standalone: true}">
      </kendo-combobox>
    </label>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelFilter()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton (click)="saveFilter()" [primary]="true" [disabled]="filterForm.invalid">
      {{ 'SAVE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>